import api from "../../../Services/api";

export const fetchUserProfile = async () => {
  const response = await api.post("/auth/me", {});
  return response.data.data;
};